import { CreditCard, Wallet2, Check } from "react-bootstrap-icons";
import { useEffect, useState } from "react";
import axiosInstance from "../../axios";
import urls from "../../Utils/urls";
import StripePaymentForm from "./StripePaymentForm";
import { StripeWrapper } from "./StripeWrapper";
import { BsSlashCircle } from "react-icons/bs";

const PaymentStep = ({
  method,
  setMethod,
  submitFlag,
  onSuccess,
  data,
  setStripeLoaded,
  setSubmitLoading,
  email,
  validLoanNumber,
  propertyAddress,
  invoiceID,
  setInvoiceID,
  paymentIntentId,
  setPaymentIntentId,
  vomNumber,
  loanStatus,
}) => {
  const [clientSecret, setClientSecret] = useState(null);
  // console.log({ paymentIntentId });

  useEffect(() => {
    const fetchClientSecret = async () => {
      try {
        const headers = {
          "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
        };

        const res = await axiosInstance.post(
          urls.VOM.fetchClientSecretForStripe,
          {
            amount: 30,
            requestorEmail: email,
            loanNumber: validLoanNumber,
            propertyAddress,
            vomNumber
          },
          { headers },
        );

        setStripeLoaded(true);
        setClientSecret(res?.data?.clientSecret);
        // setInvoiceID(res?.data?.paymentIntentId);
        setPaymentIntentId(res?.data?.paymentIntentId);
      } catch (error) {
        console.error("Failed to fetch client secret", error);
      }
    };

    if (method === "stripe") {
      fetchClientSecret();
    }
  }, [method]);

  return (
    <div className="payment-step">
      {/* HEADER */}

      {/* INFO BOX */}
      <div className="payment-info text-start">
        <CreditCard size={18} className="mt-2" />
        <div>
          <strong>Choose Payment Method</strong>
          {loanStatus === "Paid off" ? (
            <p>
              VOM fee must be paid upfront through Stripe. The “Add to
              Borrower’s Account” option is not available for paid-off loans.
            </p>
          ) : (
            <p>Select how you would like to pay for this VOM request.</p>
          )}
        </div>
      </div>

      {/* PAYMENT METHODS */}
      <div className="payment-methods">
        {/* STRIPE */}
        <div
          className={`payment-card-vom ${
            loanStatus === "Paid off" || method === "stripe" ? "selected" : ""
          } text-start`}
          style={{ cursor: loanStatus === "Paid off" ? "default" : "pointer" }}
          onClick={() => setMethod("stripe")}
        >
          <div
            className={`card-icon ${loanStatus === "Paid off" || method === "stripe" ? "active" : ""}`}
          >
            <CreditCard size={20} />
          </div>

          <div className="card-content">
            <h5 className="text-black">
              Pay with Stripe{" "}
              {loanStatus === "Paid off" && (
                <span className="text-muted">(Required)</span>
              )}
            </h5>
            <p>Secure online payment via credit/debit card</p>

            <div className="card-brands">
              <span className="badge-muted">Visa</span>
              <span className="badge-muted">Mastercard</span>
              <span className="badge-muted">Amex</span>
            </div>

            {(loanStatus === "Paid off" || method === "stripe") && (
              <>
                <div className="fee-divider" />
                <div className="selected-indicator">
                  <Check /> Selected
                </div>
              </>
            )}
          </div>
        </div>

        {/* BORROWER ACCOUNT */}
        <div
          className={`payment-card-vom ${
            method === "borrower" ? "selected" : ""
          } text-start`}
          onClick={() => setMethod("borrower")}
          style={{
            opacity: loanStatus === "Paid off" ? 0.5 : 1,
            pointerEvents: loanStatus === "Paid off" ? "none" : "auto",
            backgroundColor:
              loanStatus === "Paid off" ? "#f8f9fa" : "transparent",
          }}
        >
          <div className={`card-icon ${method === "borrower" ? "active" : ""}`}>
            <Wallet2 size={20} />
          </div>

          <div className="card-content">
            <h5 className="text-black">Add to Borrower's Account</h5>
            <p>Charge this fee to the borrower's loan account</p>

            <span className="badge-muted">Invoice later</span>
            {loanStatus === "Paid off" && (
              <span className="badge-disabled">
                <BsSlashCircle size={12} /> Unavailable
              </span>
            )}
            {method === "borrower" && (
              <>
                <div className="fee-divider" />
                <div className="selected-indicator">
                  <Check /> Selected
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {method === "stripe" && clientSecret && (
        <StripeWrapper clientSecret={clientSecret}>
          <StripePaymentForm
            onSuccess={onSuccess}
            submitFlag={submitFlag}
            data={data}
            setStripeLoaded={setStripeLoaded}
            setSubmitLoading={setSubmitLoading}
            paymentIntentId={paymentIntentId}
            clientSecret={clientSecret}
          />
        </StripeWrapper>
      )}

      {/* FEE SUMMARY */}
      <div className="fee-summary">
        <h5 className="text-start">Fee Summary</h5>

        <div className="fee-row">
          <span>VOM Request Fee</span>
          <span>$30.00</span>
        </div>

        <div className="fee-divider" />

        <div className="fee-row total">
          <span>Total</span>
          <span>$30.00</span>
        </div>
      </div>

      {/* FOOTER */}
    </div>
  );
};

export default PaymentStep;
